"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondaryNavListDefaultProps = exports.secondaryNavDefaultProps = exports.SECONDARY_NAV_TEXT_COLOR = exports.SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = exports.SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = exports.SECONDARY_NAV_ITEM_OUTLINE_WIDTH = exports.SECONDARY_NAV_ITEM_OUTLINE_RADIUS = exports.SECONDARY_NAV_ITEM_OUTLINE_COLOR = exports.SECONDARY_NAV_ITEM_LARGE_MARGIN_RIGHT = exports.SECONDARY_NAV_ITEM_BORDER_COLOR = exports.SECONDARY_NAV_HOVER_BACKGROUND_COLOR = exports.SECONDARY_NAV_HEIGHT = exports.SECONDARY_NAV_DROPDOWN_LIST_PADDING = exports.SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = exports.SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = exports.SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = exports.SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = exports.SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = exports.SECONDARY_NAV_BORDER_SIZE = exports.SECONDARY_NAV_BORDER_COLOR = exports.SECONDARY_NAV_BACKGROUND_COLOR = void 0;
var SECONDARY_NAV_HEIGHT = 'S700';
exports.SECONDARY_NAV_HEIGHT = SECONDARY_NAV_HEIGHT;
var SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = 'S300';
exports.SECONDARY_NAV_ITEM_PADDING_HORIZONTAL = SECONDARY_NAV_ITEM_PADDING_HORIZONTAL;
var SECONDARY_NAV_ITEM_LARGE_MARGIN_RIGHT = 'S500';
exports.SECONDARY_NAV_ITEM_LARGE_MARGIN_RIGHT = SECONDARY_NAV_ITEM_LARGE_MARGIN_RIGHT;
var SECONDARY_NAV_ITEM_OUTLINE_WIDTH = 2;
exports.SECONDARY_NAV_ITEM_OUTLINE_WIDTH = SECONDARY_NAV_ITEM_OUTLINE_WIDTH;
var SECONDARY_NAV_ITEM_OUTLINE_RADIUS = 'R100';
exports.SECONDARY_NAV_ITEM_OUTLINE_RADIUS = SECONDARY_NAV_ITEM_OUTLINE_RADIUS;
var SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = 'S100';
exports.SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT = SECONDARY_NAV_ITEM_SELECTION_INDICATOR_HEIGHT;
var SECONDARY_NAV_DROPDOWN_LIST_PADDING = 'S200';
exports.SECONDARY_NAV_DROPDOWN_LIST_PADDING = SECONDARY_NAV_DROPDOWN_LIST_PADDING;
var SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = 'S200';
exports.SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING = SECONDARY_NAV_DROPDOWN_ITEM_HORIZONTAL_PADDING;
var SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = 'S300';
exports.SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING = SECONDARY_NAV_DROPDOWN_ITEM_VERTICAL_PADDING;
var SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = 220;
exports.SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH = SECONDARY_NAV_DROPDOWN_ITEM_MIN_WIDTH;
var SECONDARY_NAV_BORDER_SIZE = 1;
exports.SECONDARY_NAV_BORDER_SIZE = SECONDARY_NAV_BORDER_SIZE;
var SECONDARY_NAV_TEXT_COLOR = 'neutral90';
exports.SECONDARY_NAV_TEXT_COLOR = SECONDARY_NAV_TEXT_COLOR;
var SECONDARY_NAV_BACKGROUND_COLOR = 'neutral0';
exports.SECONDARY_NAV_BACKGROUND_COLOR = SECONDARY_NAV_BACKGROUND_COLOR;
var SECONDARY_NAV_HOVER_BACKGROUND_COLOR = 'neutral05';
exports.SECONDARY_NAV_HOVER_BACKGROUND_COLOR = SECONDARY_NAV_HOVER_BACKGROUND_COLOR;
var SECONDARY_NAV_BORDER_COLOR = 'neutral20';
exports.SECONDARY_NAV_BORDER_COLOR = SECONDARY_NAV_BORDER_COLOR;
var SECONDARY_NAV_ITEM_OUTLINE_COLOR = 'neutral100';
exports.SECONDARY_NAV_ITEM_OUTLINE_COLOR = SECONDARY_NAV_ITEM_OUTLINE_COLOR;
var SECONDARY_NAV_ITEM_BORDER_COLOR = 'neutral80';
exports.SECONDARY_NAV_ITEM_BORDER_COLOR = SECONDARY_NAV_ITEM_BORDER_COLOR;
var SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = 'neutral90';
exports.SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR = SECONDARY_NAV_DROPDOWN_ITEM_TEXT_COLOR;
var SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = 'neutral05';
exports.SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR = SECONDARY_NAV_DROPDOWN_ITEM_HOVER_COLOR;
var secondaryNavDefaultProps = {
  'aria-label': 'Secondary',
  top: 0
};
exports.secondaryNavDefaultProps = secondaryNavDefaultProps;
var secondaryNavListDefaultProps = {
  dropdownHiddenLabel: 'Select a page',
  shouldCollapseToDropdown: ['s', 'm']
};
exports.secondaryNavListDefaultProps = secondaryNavListDefaultProps;